import { apiContainer } from '@vlabs/api-bindings';
import type { LunaClient } from '@vlabs/api-bindings';

import { handlerICAO } from '@vlabs/shared/payloads/handlers';

export interface EstimateIcaoComplianceProps {
  handlerId: string;
  file?: File;
  raw?: boolean;
}

export type EstimateIcaoComplianceReturn = Promise<Record<string, unknown> | undefined>;

export async function estimateIcaoCompliance({
  handlerId,
  file,
  raw = false,
}: EstimateIcaoComplianceProps): EstimateIcaoComplianceReturn {
  if (!file || !handlerId) return undefined;
  const data = await (apiContainer.lunaClient as LunaClient).events.emit(
    handlerId,
    file,
    { policies: handlerICAO.policies },
  );

  if (raw) return data._raw;
  if (data.events?.length > 0) return data.events[0];
  return data;
}
